import React from 'react'
import { useTheme } from '../../designable/react'
import formatic2 from '../../resources/logo_informatics.png'
const logo = {
  dark: '//img.alicdn.com/imgextra/i2/O1CN01NTUDi81fHLQvZCPnc_!!6000000003981-55-tps-1141-150.svg',
  light:
    '//img.alicdn.com/imgextra/i2/O1CN01Kq3OHU1fph6LGqjIz_!!6000000004056-55-tps-1141-150.svg',
}

export const LogoWidget: React.FC = () => {
  const theme = useTheme() as "dark" | "light"
  const url = logo[theme]
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img
        alt=""
        src={formatic2}
        style={{ margin: '12px 8px', height: '40px', width: 'auto' }}
      />
      {/* <h1>FORMATIC</h1> */}
    </div>
  )
}
